import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import style from "./RequestPage.module.css"
import ReCAPTCHA from 'react-google-recaptcha';

const RequestPage = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_mdpbkwq', 'template_u57418h', form.current, 'pxbyGIV-xa1Y6d4ky')
      .then((result) => {
        console.log(result.text);
        console.log("message sent")
      }, (error) => {
        console.log(error.text);
      });
  };

  function onChange(value) {
    console.log("Captcha value:", value);
  }

  return (
    <div className={style.body}>
      <form className={style.form} ref={form} onSubmit={sendEmail}>
        <label>Name</label>
        <input type="text" name="user_name" placeholder='Full Name' />
        <label>Email</label>
        <input type="email" name="user_email" placeholder='Email' />
        <label>Problem</label>
        <textarea className={style.textarea} name="message" placeholder='What you want to upgrade?' />
        <ReCAPTCHA
        className={style.captcha}
          sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
          onChange={onChange}
        />
        <button className={style.glow_on_hover} type="submit" value="Send" >Order UPGRADE with a discount</button>
      </form>
    </div>
  );
};
export default RequestPage;